module.exports = __webpack_public_path__ + "img/title2.181eaf36.png";